import styled from 'styled-components';
import React from 'react';

// RS3: mostrado quando o link de acesso à entrevista (token na query string `t`)
// é inválido, expirado ou adulterado — o backend já rejeita a leitura/gravação
// nesses casos, mas antes disso não existia nenhum aviso pro candidato, que via
// a tela seguir normalmente (intro/formulário/tour) sem que nada fosse salvo.
export default function AccessErrorContainer() {
  return (
    <EndContainer>
      <h1>Não foi possível abrir esta entrevista</h1>
      <p>O link usado é inválido ou expirou, e por isso nenhuma resposta pôde ser carregada ou salva.</p>
      <p>Peça um novo link para quem te convidou para essa entrevista.</p>
    </EndContainer>
  );
}

const EndContainer = styled.div`
  height: 100vh;
  width: 100vw;
  background-color: #F8F9FB;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 25px;
  h1 {
    font-size: 34px;
    color: #333;
    font-family: "Poppins", sans-serif;
  }
  p {
    font-size: 18px;
    color: #666;
    font-family: "Poppins", sans-serif;
    margin-top: 10px;
    max-width: 520px;
  }
`;
